var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Typography, Menu } from "antd";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
const generateMenuItems = (navigation) => {
    const menuItems = [];
    navigation.forEach((_a) => {
        var { key, path, label, dropdown } = _a, rest = __rest(_a, ["key", "path", "label", "dropdown"]);
        const menuItem = Object.assign(Object.assign({}, rest), { key: path || key, label: (_jsx(Typography.Link, { "data-testid": `link-${label}`, children: label })) });
        if (dropdown) {
            menuItem.children = generateMenuItems(dropdown);
            menuItem.label = label;
        }
        menuItems.push(menuItem);
    });
    return menuItems;
};
/**
 * A navigation menu that displays a list of items.
 * Handles clicks and highlights the selected item.
 */
const NavigationMenu = (_a) => {
    var { selected, navigation } = _a, props = __rest(_a, ["selected", "navigation"]);
    const [selectedLocal, setSelectedLocal] = useState(selected !== null && selected !== void 0 ? selected : "");
    useEffect(() => {
        setSelectedLocal((prevSelection) => selected !== null && selected !== void 0 ? selected : prevSelection);
    }, [selected]);
    const onHandleClick = (e) => {
        setSelectedLocal(e.key);
        if (!props.onClick)
            return;
        props.onClick(e);
    };
    return (_jsx(Menu, Object.assign({ mode: "horizontal", items: generateMenuItems(navigation) }, props, { onClick: onHandleClick, selectedKeys: [selectedLocal] })));
};
/** @deprecated Routing should not be a dependency of the component in the future, please use generateMenuItems instead */
const generateRouteMenuItems = (navigation) => {
    return navigation.reduce((items, item) => {
        if (item.visible === false)
            return items;
        return [
            ...items,
            item.dropdown
                ? {
                    key: item.path,
                    label: item.label,
                    children: item.dropdown.map((dropdownItem) => ({
                        key: dropdownItem.path,
                        // open: true,
                        label: (_jsx(Link, { "data-testid": `link-${dropdownItem.label}`, to: dropdownItem.redirectTo
                                ? dropdownItem.redirectTo
                                : dropdownItem.path, children: dropdownItem.label }))
                    }))
                }
                : {
                    key: item.path,
                    label: (_jsx(Link, { "data-testid": `link-${item.label}`, to: item.redirectTo ? item.redirectTo : item.path, children: item.label }))
                }
        ];
    }, []);
};
/**
 * @deprecated Routing should not be a dependency of the component in the future, please use NavigationMenu instead.
 */
const RouteNavigationMenu = (props) => {
    var _a;
    const [selectedLocal, setSelectedLocal] = useState((_a = props.selected) !== null && _a !== void 0 ? _a : "");
    const onHandleClick = (e) => {
        setSelectedLocal(e.key);
        if (!props.onClick)
            return;
        props.onClick(e);
    };
    return (_jsx(Menu, Object.assign({ mode: "horizontal", items: generateRouteMenuItems(props.navigation) }, props, { onClick: onHandleClick, selectedKeys: [selectedLocal] })));
};
/**
 * A navigation menu that displays a list of items.
 * Routing should generally be handled by the product (set useBuiltInRouter to false).
 * usage: `<TopbarContent.NavigationMenu {...} />`
 */
export const NavigationMenuWrapper = (_a) => {
    var { useBuiltInRouter } = _a, rest = __rest(_a, ["useBuiltInRouter"]);
    if (useBuiltInRouter === true) {
        const props = rest;
        return _jsx(RouteNavigationMenu, Object.assign({}, props));
    }
    const props = rest;
    return _jsx(NavigationMenu, Object.assign({}, props));
};
NavigationMenuWrapper.displayName = "NavigationMenuWrapper"; // prevent name from being minified
